export default __webpack_public_path__ + "static/media/eighteen-plus.2fb1ee3d.png";